import React from 'react'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'
import {
  dialogCheckboxSx,
  dialogEmailTextSx,
  dialogNameTextSx
} from '../../../constants/dialogSx'
import {
  getRbacUserDisplayName,
  getRbacUserInitials,
  getRbacUserPrimaryRoleName
} from '../../pages/shared/rbacUserDetailHelpers'
import { RbacRoleChip } from '../RbacChips'
import {
  RBAC_ADD_USERS_UNASSIGNED_ROLE_LABEL,
  rbacAddUsersAvatarSx,
  rbacAddUsersRowSx
} from '../constants/rbacAddUsersToRoleDialogConstants'

export default function RbacAddUsersListItem({ user, selected, onToggle }) {
  const primaryRoleName = getRbacUserPrimaryRoleName(user)
  const hasUnassignedRole = primaryRoleName === RBAC_ADD_USERS_UNASSIGNED_ROLE_LABEL
  const displayName = getRbacUserDisplayName(user)

  return (
    <Box sx={rbacAddUsersRowSx}>
      <Checkbox
        checked={selected}
        onChange={() => onToggle(user.id)}
        inputProps={{ 'aria-label': `Seleccionar a ${displayName}` }}
        sx={dialogCheckboxSx}
      />
      <Avatar sx={rbacAddUsersAvatarSx}>{getRbacUserInitials(displayName)}</Avatar>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={dialogNameTextSx}>{displayName}</Typography>
        <Typography sx={dialogEmailTextSx}>{user.email || '—'}</Typography>
      </Box>
      <RbacRoleChip
        label={
          hasUnassignedRole
            ? RBAC_ADD_USERS_UNASSIGNED_ROLE_LABEL
            : String(primaryRoleName).toUpperCase()
        }
        unassigned={hasUnassignedRole}
      />
    </Box>
  )
}
